import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';
import { media } from 'src/theme/breakpoints';
import { PREVIEW_BAR_HEIGHT } from 'src/const/common';
const HeaderQuoteDetailStyle = styled('div')`
    &.preview {
        padding-top: var(--preview-bar-height, ${PREVIEW_BAR_HEIGHT.desktop}px);

        .sticky-active .box-multiple-title {
            top: var(--preview-bar-height, ${PREVIEW_BAR_HEIGHT.desktop}px);
        }

        ${media.mobile} {
            padding-top: var(
                --preview-bar-height,
                ${PREVIEW_BAR_HEIGHT.mobile}px
            );

            .sticky-active .box-multiple-title {
                top: var(--preview-bar-height, ${PREVIEW_BAR_HEIGHT.mobile}px);
            }
        }
    }

    .box-preview {
        background-color: var(--sand-300);
        position: fixed;
        width: 100%;
        z-index: 99;
        padding: 16px 0;
        color: var(--sand-600);
        ${typography.bodyL}
        top: 0;
        left: 0;

        .role {
            padding: 8px 0;
            strong {
                font-weight: 700;
            }
        }

        .ant-btn {
            ${typography.buttonMd}
        }

        .ant-btn-primary:not(:disabled) {
            color: var(--sand-100);
        }

        .btn-outline {
            border-width: 1px;
        }

        .btn-outline:not(:disabled) {
            background-color: var(--sand-100);
            border: 1px solid var(--sand-700);
            color: var(--sand-700);
            &:hover {
                background-color: var(--sand-300);
                border-color: var(--sand-700);
                color: var(--sand-700);
            }
        }

        .btn-secondary:not(:disabled) {
            background-color: var(--burgundy-800);
            border-color: var(--burgundy-800);
            &:hover {
                background-color: var(--burgundy-700);
                border-color: var(--burgundy-700);
            }
        }
    }

    .box-header {
        padding-top: 24px;
        // padding-bottom: 20px;
        font-weight: 700;
        font-size: 20px;
        background: var(--burgundy-800);
        color: var(--white);

        .logo {
            width: 196px;
            img {
                display: block;
                width: 100%;
                height: auto;
            }
        }

        .ref {
            padding-top: 0;
            text-align: right;
            ${typography.bodyL}
            color: var(--white);
        }

        .promotion {
            display: flex;
            align-items: center;
            border: 2px solid;
            color: var(--orange-300);
            border-radius: 6px;
            ${typography.bodyXl}
            justify-content: center;
            min-height: 64px;
            padding: 8px 1rem;
            margin-top: 1rem;

            .iconCoins {
                margin-right: 1.5rem;
                font-size: 28px;
            }
        }
    }

    .banner {
        height: 180px;
        .img-banner {
            display: block;
            height: 100%;
            width: 100%;
            object-fit: fill;
        }
        .skeleton-image {
            width: 100%;
            height: 180px;
        }
    }

    @media screen and (max-width: 767px) {
        .box-preview {
            .role {
                padding: 0;
                text-align: center;
            }
        }
        .box-header {
            padding-top: 24px;
            font-size: 16px;
            .logo {
                width: 168px;
            }
            .ref {
                padding-top: 0px;
                ${typography.bodySm}
            }
        }

        .banner {
            height: auto;
            .img-banner {
                object-position: 0px;
                height: auto;
            }
        }
    }
`;
export default HeaderQuoteDetailStyle;
